import { render } from "./BaseInvitation.vue?vue&type=template&id=b6a28aea"
import script from "./BaseInvitation.vue?vue&type=script&lang=js"
export * from "./BaseInvitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__